import { flatten, unflatten } from 'flat';
import _get from 'lodash/get';

export const formStateFallback = (values: object, defaultValues: object) => {
  const keys = Object.keys({
    ...flatten(values || {}, { safe: true }),
    ...flatten(defaultValues || {}, { safe: true })
  });
  const entries = keys.map(key => [key, _get(defaultValues, key, null)]);

  return unflatten(Object.fromEntries(entries)) as object;
};
